function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { asMultiStyleConfig } from '../../utils/theme';
import { getColor } from '../../theme-tools';
var parts = ['container', 'text', 'iconWrapper'];
var baseStyle = props => {
  var {
    theme,
    isDragAccept,
    isDragReject
  } = props;
  var styles = {
    border: "1px solid ".concat(getColor(theme, 'grey.300')),
    bg: 'grey.100'
  };
  if (isDragAccept) {
    styles.border = "2px dashed ".concat(getColor(theme, 'blue.600'));
    styles.bg = 'blue.1130';
  } else if (isDragReject) {
    styles.border = "2px solid ".concat(getColor(theme, 'red.700'));
    styles.bg = 'red.1050';
  }
  return {
    container: _objectSpread(_objectSpread({
      p: 6,
      cursor: 'pointer',
      minHeight: '7.75rem',
      borderRadius: '0.5rem',
      alignItems: 'center',
      justifyContent: 'center',
      display: 'flex'
    }, styles), {}, {
      _focusVisible: {
        boxShadow: "0 0 4px 1px ".concat(getColor(theme, 'blue.300')),
        outline: 'none'
      },
      _active: {
        border: {
          base: "2px dashed ".concat(getColor(theme, 'blue.600')),
          sm: "1px solid ".concat(getColor(theme, 'grey.300'))
        },
        bg: {
          base: 'blue.1130',
          sm: 'grey.100'
        }
      }
    }),
    text: {
      color: 'grey.800',
      fontWeight: 'semibold',
      wordBreak: 'break-word',
      mb: 0
    },
    iconWrapper: {
      width: 12,
      height: 'auto',
      color: isDragReject ? 'red.700' : 'blue.600',
      flexShrink: 0,
      mr: 4,
      svg: {
        width: '100%',
        height: 'auto'
      }
    }
  };
};
export default asMultiStyleConfig({
  parts,
  baseStyle
});